/**
 *  A dedicated Reducer for the Organizational Chart (staff view + HR manage pages)
 */
const initState = {
  charts: [],          // published charts (staff view)
  isLoaded: false,
  loadError: false,
  manage: [],          // HR chart list
  manageLoaded: false,
  draft: null,         // HR editor payload: { chart, items, groups, levels }
  draftError: false,
};

const orgChartReducers = (state = initState, action) => {
  switch (action.type) {
    case "ORG_CHARTS_LOADED":
      return { ...state, charts: Array.isArray(action.charts) ? action.charts : [], isLoaded: true, loadError: false };
    case "ORG_CHARTS_FAILED":
      return { ...state, loadError: true };
    case "ORG_CHART_MANAGE_LOADED":
      return { ...state, manage: Array.isArray(action.charts) ? action.charts : [], manageLoaded: true };
    case "ORG_CHART_MANAGE_REMOVED":
      return { ...state, manage: state.manage.filter((c) => c.id !== action.id) };
    case "ORG_CHART_DRAFT_CLEAR":
      return { ...state, draft: null, draftError: false };
    case "ORG_CHART_DRAFT_LOADED":
      return { ...state, draft: action.draft, draftError: false };
    case "ORG_CHART_DRAFT_FAILED":
      return { ...state, draftError: true };
    default:
      return state;
  }
};

export default orgChartReducers;
